import api from './api';

export interface Proveedor {
  nombre: string;
  codigo_proveedor?: string | null;
  totalProductos: number;
  productosActivos: number;
  estado: boolean;
  desglose?: { maestro: number; novias: number };
}

class ProveedorService {
  /**
   * Obtener todos los proveedores
   */
  async getProveedores(params?: { search?: string }) {
    const response = await api.get('/proveedores', { params });
    return response.data;
  }

  /**
   * Obtener un proveedor por nombre
   */
  async getProveedorById(nombre: string) {
    const response = await api.get(`/proveedores/${encodeURIComponent(nombre)}`);
    return response.data;
  }

  /**
   * Crear nuevo proveedor
   */
  async createProveedor(data: { nombre: string; codigo_proveedor: string }) {
    const response = await api.post('/proveedores', data);
    return response.data;
  }

  /**
   * Actualizar proveedor
   */
  async updateProveedor(nombreActual: string, data: { nombre: string; codigo_proveedor?: string }) {
    const response = await api.put(`/proveedores/${encodeURIComponent(nombreActual)}`, data);
    return response.data;
  }

  /**
   * Desactivar proveedor
   */
  async deactivateProveedor(nombre: string) {
    const response = await api.delete(`/proveedores/${encodeURIComponent(nombre)}`);
    return response.data;
  }

  /**
   * Activar proveedor
   */
  async activateProveedor(nombre: string) {
    const response = await api.post(`/proveedores/${encodeURIComponent(nombre)}/activate`);
    return response.data;
  }
}


export const proveedorService = new ProveedorService();
export default proveedorService;
